<template>
  <node-view-wrapper as="span">
    <v-card
        class="d-inline-flex px-0 py-0"
        outlined
        tile
        :height="node.attrs.width * 9 / 16"
    >
      <iframe
          :src="node.attrs.src"
          :width="node.attrs.width"
          :height="node.attrs.height"
          class="mt-0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
          @click.stop="dialog = true"
      ></iframe>
      <v-menu
          v-if="editor.options.editable"
          open-on-hover
          close-delay="1000"
          auto
          offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              icon
              x-small
              class="ml-n5 mt"
          >
            <v-icon small>mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-card width="400" class="px-5 py-5" dark height="50">
          <v-row>
            <v-slider
                v-model="node.attrs.width"
                class="align-self-stretch mb-n5"
                min="50"
                max="1000"
                step="10"
                :label="'Width:' + node.attrs.width"
                @change="onChange()"
            ></v-slider>
            <v-btn icon small :href="node.attrs.src" target="_blank">
              <v-icon>mdi-link</v-icon>
            </v-btn>
          </v-row>
        </v-card>

      </v-menu>
    </v-card>
  </node-view-wrapper>
</template>

<script>
import {NodeViewWrapper, nodeViewProps} from '@tiptap/vue-2';

export default {
  components: {
    NodeViewWrapper
  },
  props: nodeViewProps,
  data() {
    return {
      dialog: false,
      isResizing: true,
      lastMovement: 0,
      aspectRatio: 0
    };
  },
  computed: {
    isDraggable() {
      return this.node?.attrs?.isDraggable;
    }
  },
  mounted() {
    // this.$refs.resizableImg.onload = () => {
    //   this.aspectRatio = this.$refs.resizableImg.naturalWidth / this.$refs.resizableImg.naturalHeight;
    // };
  },
  methods: {
    onChange() {
      // console.log('onChange', this)
      this.editor.callbacks.update[0]()
    },
  }
};
</script>